class SearchModal extends HTMLElement {
  connectedCallback() {
    this.opener = this.querySelector('[data-search-modal-open]');
    this.dialog = this.querySelector('[data-command-search-dialog]');
    this.closeButton = this.querySelector('[data-command-search-close]');
    this.predictiveSearch = this.querySelector('predictive-search');

    if (!this.opener || !this.dialog) return;

    this.onOpen = this.open.bind(this);
    this.onCloseRequest = this.close.bind(this);
    this.onDialogClose = this.handleDialogClose.bind(this);
    this.onDialogCancel = this.handleDialogCancel.bind(this);

    this.opener.addEventListener('click', this.onOpen);
    this.closeButton?.addEventListener('click', this.onCloseRequest);
    this.dialog.addEventListener('close', this.onDialogClose);
    this.dialog.addEventListener('cancel', this.onDialogCancel);
  }

  disconnectedCallback() {
    this.opener?.removeEventListener('click', this.onOpen);
    this.closeButton?.removeEventListener('click', this.onCloseRequest);
    this.dialog?.removeEventListener('close', this.onDialogClose);
    this.dialog?.removeEventListener('cancel', this.onDialogCancel);

    if (this.dialog?.open) document.body.classList.remove('search-modal--open');
  }

  open(event) {
    if (typeof this.dialog.showModal !== 'function') return;
    event.preventDefault();
    if (this.dialog.open) return;

    this.lastFocusedElement = document.activeElement;
    this.dialog.showModal();
    document.body.classList.add('search-modal--open');
    this.predictiveSearch?.focusInput();
    document.dispatchEvent(new CustomEvent('searchmodal:open', { detail: { dialog: this.dialog } }));
  }

  close() {
    if (!this.dialog.open) return;
    this.predictiveSearch?.clear({ focus: false });
    this.dialog.close();
  }

  handleDialogCancel(event) {
    if (this.predictiveSearch?.handleEscape() === 'clear') event.preventDefault();
  }

  handleDialogClose() {
    document.body.classList.remove('search-modal--open');
    document.dispatchEvent(new CustomEvent('searchmodal:close', { detail: { dialog: this.dialog } }));

    const focusTarget = this.lastFocusedElement?.isConnected ? this.lastFocusedElement : this.opener;
    focusTarget?.focus();
  }
}

if (typeof customElements.get !== 'function' || !customElements.get('search-modal')) {
  customElements.define('search-modal', SearchModal);
}
